import React from 'react';

export const SustainmentIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
  >
    <path
      d="M3.125 12.5C3.125 10.0136 4.11272 7.62903 5.87087 5.87087C7.62903 4.11272 10.0136 3.125 12.5 3.125C15.1209 3.13486 17.6365 4.15752 19.5208 5.97917L21.875 8.33333"
      stroke="#317CEC"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.875 3.125V8.33333H16.6666"
      stroke="#317CEC"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.875 12.5C21.875 14.9864 20.8873 17.371 19.1291 19.1291C17.371 20.8873 14.9864 21.875 12.5 21.875C9.87912 21.8651 7.36351 20.8425 5.47917 19.0208L3.125 16.6667"
      stroke="#317CEC"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33333 16.6667H3.125V21.875"
      stroke="#317CEC"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
